var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportantIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 20,
    rx: 10,
    fill: "#D32F2F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.12476C9.90326 4.12476 9.33097 4.36181 8.90901 4.78377C8.48705 5.20572 8.25 5.77802 8.25 6.37476C8.25 8.04501 8.84175 10.2778 9.16875 11.3885C9.2542 11.6747 9.43012 11.9255 9.67013 12.1033C9.91013 12.2811 10.2013 12.3764 10.5 12.3748C11.1075 12.3748 11.655 11.9863 11.8312 11.3923C12.159 10.2845 12.75 8.06226 12.75 6.37476C12.75 5.77802 12.5129 5.20572 12.091 4.78377C11.669 4.36181 11.0967 4.12476 10.5 4.12476ZM10.5 13.8748C10.1022 13.8748 9.72064 14.0328 9.43934 14.3141C9.15804 14.5954 9 14.9769 9 15.3748C9 15.7726 9.15804 16.1541 9.43934 16.4354C9.72064 16.7167 10.1022 16.8748 10.5 16.8748C10.8978 16.8748 11.2794 16.7167 11.5607 16.4354C11.842 16.1541 12 15.7726 12 15.3748C12 14.9769 11.842 14.5954 11.5607 14.3141C11.2794 14.0328 10.8978 13.8748 10.5 13.8748Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportantIcon);
export default __webpack_public_path__ + "static/media/important-icon.f11b2626b41caf256d2a57ad6d733cdd.svg";
export { ForwardRef as ReactComponent };